<script lang="ts">
import { stripSiteDomain } from '$lib/utils/url.js';
import Link from '../../atoms/Link/Link.svelte';

interface CtaImage {
    src?: string;
    alt?: string;
}

interface Props {
    text?: string;
    ctaText?: string;
    ctaLink?: string;
    images?: CtaImage[];
    hideBlock?: boolean;
}

let {
    text = 'Speak to us about your brand’s Technical Strategy',
    ctaText = 'Contact us',
    ctaLink = '#contact',
    images = [],
    hideBlock = false,
}: Props = $props();

let href = $derived(stripSiteDomain(ctaLink));
</script>

{#if !hideBlock}
    <section class="service-contact-cta">
        {#if images.length}
            <div class="service-contact-cta__images" aria-hidden="true">
                {#each images.slice(0, 3) as image}
                    {#if image.src}
                        <img src={image.src} alt={image.alt || ''} />
                    {/if}
                {/each}
            </div>
        {/if}
        <p>{text}</p>
        <Link to={href} type="link" class="button button--inverse service-contact-cta__button">
            {#snippet text()}{ctaText}{/snippet}
        </Link>
    </section>
{/if}

<style lang="scss">
    .service-contact-cta {
        align-items: center;
        background: var(--colour-pickled-pineapple);
        display: flex;
        flex-direction: column;
        gap: 1.6rem;
        justify-content: center;
        padding: 4rem 1.6rem;
        text-align: center;
    }

    .service-contact-cta__images {
        display: flex;
        gap: 0.5rem;
    }

    img {
        height: 6.1rem;
        mix-blend-mode: multiply;
        object-fit: cover;
        width: 6.1rem;
    }

    p {
        color: var(--colour-dreamless-sleep);
        font-size: 1.6rem;
        line-height: 1.4;
        margin: 0;
    }

    :global(.service-contact-cta__button) {
        border-color: var(--colour-dreamless-sleep);
    }
</style>
